import { createContext, useContext } from "react";

// NOTE: Contract that page-level guards (e.g. `useUploadNavigationGuard`)
// implement to opt into intercepting `useNavigate()` / `<Link>` clicks. The
// `NavigationGuardProvider` polls every registered guard's `shouldBlock`
// before each `navigator.push` / `replace`; the first to return `true`
// gets ownership of the navigation via `onBlock(proceed)` and decides
// whether to call `proceed()` (after user confirms) or drop it.
export interface INavigationGuard {
  shouldBlock: () => boolean;
  onBlock: (proceed: () => void) => void;
}

export interface INavigationGuardContextValue {
  registerGuard: (id: string, guard: INavigationGuard) => void;
  unregisterGuard: (id: string) => void;
}

export const NavigationGuardContext =
  createContext<INavigationGuardContextValue | null>(null);

// NOTE: Returns `null` when used outside `<NavigationGuardProvider>`. Callers
// must tolerate that — the upload guard falls back to its
// `beforeunload` + `popstate` intercepts in that case (e.g. unit tests).
export const useNavigationGuard = (): INavigationGuardContextValue | null => {
  return useContext(NavigationGuardContext);
};
